import apiProvider from './provider';
import { API_BASE_URL, BASE_URL } from 'src/globals';
import {
  CREATE_SALES_ORDER,
  CREATE_MULTIPLE_SALES_ORDER,
  FETCH_SALES_ORDERS,
  FETCH_SALER_ORDER_DETAILS,
  ADD_EDIT_SALES_ORDER_BOOKING_DETAILS,
  ADD_EDIT_SALES_ORDER_PAYMENT_DETAILS,
  FETCH_DO_LIST_FROM_SO,
  CREATE_DO_SO,
  EDIT_DO_SO,
  DO_CONTAINER_ADD,
  CUSTOMS_CLEARANCE_SO,
  APPROVE_DRAFT_BL_SO,
  CREATE_DOCUMENT_SO,
  GET_S3_UPLOAD_LINKS,
  RAKE_SEARCH,
  ASSIGN_CHA_TO_SO,
  ASSIGN_SHIPPING_LINE_TO_SO,
  GET_DO_LIST,
  EDIT_SALES_ORDER,
  CREATE_SO_CONTAINER,
  EDIT_SO_CONTAINER,
  STUFF_CONTAINERS,
  ASSIGN_FF_TO_SO,
} from './routes';
import {
  getAuthenticationHeaders,
  getErrorMessage,
  generateQueryString,
  generateObjectFromList,
} from './utils';
import { AxiosResponse } from 'axios';
import { ApiResponseWrapper } from './apiHandler';

export const postMultipleSalesOrder = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + CREATE_MULTIPLE_SALES_ORDER, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const postSalesOrderItem = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${CREATE_SALES_ORDER}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const postAssignFFtoSO = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + ASSIGN_FF_TO_SO, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const postAssignCHAtoSO = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + ASSIGN_CHA_TO_SO, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const postAssignShippingLinetoSO = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + ASSIGN_SHIPPING_LINE_TO_SO, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const postEditSalesOrderItem = async (body) => {
  try {
    const response = await apiProvider.post(
      API_BASE_URL + EDIT_SALES_ORDER, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getDOList = async (soId) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${GET_DO_LIST}?so_id=${soId}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getRakesSearch = async (params: any = { queryStr: '' }) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${RAKE_SEARCH}`,
      {
        params,
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getSalesOrdersData = async (
  batchSize,
  rakeNumbers,
  status,
  shippingLines,
  cha,
  ff,
  originPort,
  destinationPort,
  sortBy,
  descendingOrder,
  currentPageNumber,
  nextOrPrev,
  lastSortedColumnValue,
  lastRowId,
  searchType, searchItems, eximType) => {
  const paramArray = [
    { key: 'batch_size', val: batchSize },
    ...generateObjectFromList('rake_number_list', rakeNumbers),
    ...generateObjectFromList('status_list', status),
    ...generateObjectFromList('shipping_line_ids', shippingLines),
    ...generateObjectFromList('cha_id_list', cha),
    ...generateObjectFromList('ff_id_list', ff),
    ...generateObjectFromList('origin_port_id_list', originPort),
    ...generateObjectFromList('destination_port_id_list', destinationPort),
    { key: 'next_or_prev', val: nextOrPrev },
    { key: 'last_sorted_column_value', val: lastSortedColumnValue },
    { key: 'last_row_id', val: lastRowId },
    { key: 'sort_by', val: sortBy },
    { key: 'descending_order', val: descendingOrder },
    { key: 'current_page_number', val: currentPageNumber },
    ...generateObjectFromList(searchType, searchItems),
    { key: 'type', val: eximType.toUpperCase() },
  ];
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${FETCH_SALES_ORDERS}?${generateQueryString(paramArray)}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );

    return {
      data: response.data.data,
      isSuccess: true,
    };

  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getSODetailsFromId = async (soId) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${FETCH_SALER_ORDER_DETAILS}?so_id=${soId}`,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const addEditSoBooking = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${ADD_EDIT_SALES_ORDER_BOOKING_DETAILS}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const addEditPaymentDetails = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${ADD_EDIT_SALES_ORDER_PAYMENT_DETAILS}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const addDO = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${CREATE_DO_SO}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editDO = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${EDIT_DO_SO}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

const dataHeaders = {
  JPG: 'image/*',
  JPEG: 'image/*',
  PNG: 'image/*',
  PDF: 'application/*',
  DOCX: 'application/*',
  XLSX: 'application/*',
  CSV: 'text/csv',
  XLS: 'application/*',
  DOC: 'application/*',
  EML:' message/rfc822',
  MSG:'application/vnd.ms-outlook',
};

export const uploadImageToS3 = async(file: File, url, extension, uploadProgressCb?: any, uid?: string, uploadMap?: any, inputKey?: string) => {
  try {
    const config = {
      headers: {
        'Content-Type': dataHeaders[extension.toUpperCase()],
      },
      onUploadProgress: progressEvent => uploadProgressCb ? uploadProgressCb(progressEvent, uid, uploadMap, inputKey) : null
    }
    const response = await apiProvider.put(
      url, file,
      {
        ...config
      },
    );
    return {
      isSuccess: response.status === 200 || response.status === 201,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getS3UploadLinks = async (type, extension) => {
  const body = {
    extension,
    document_type: type,
  };
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.post(
      `${API_BASE_URL}${GET_S3_UPLOAD_LINKS}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const addContainersToDO = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${DO_CONTAINER_ADD}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      data: response.data,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const approveDraftBLDO = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${APPROVE_DRAFT_BL_SO}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const customsClearanceSO = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${CUSTOMS_CLEARANCE_SO}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const createDocumentSO = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${CREATE_DOCUMENT_SO}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const createContainer = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${CREATE_SO_CONTAINER}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const editContainer = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${EDIT_SO_CONTAINER}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const stuffContainers = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${STUFF_CONTAINERS}`, body,
      {
        headers: getAuthenticationHeaders(),
      },
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
